/**
 * API class for calling Medten Mobile APIs.
 */
export class Api {
  constructor() {
    this.base_url = process.env.VUE_APP_API_BASE_URL || `http://localhost:3000`;
    this.api_key = process.env.VUE_APP_API_KEY || null;
    this.account_id = null;
  }

  /** Gets an event by id. */
  async getEvent(id) { return await this._get(`${this.base_url}/api/events/${id}`); }

  /** Creates an appointment */
  async createAppointment(payload) { return await this._post(`${this.base_url}/api/appointments/create`, payload); }
  
  /** Gets the default configuration */
  async getDefaultConfiguration() { return await this._get(`${this.base_url}/api/configurations/default`); }

  /** Creates a contact */
  async createContact(payload) { return await this._post(`${this.base_url}/api/contacts/create`, payload); }

  /** Gets all the product categories*/
  async getAllCategories() { return await this._get(`${this.base_url}/api/categories/all`); }

  /** Gets posts matching the criteria */
  async getEmployees(criteria) { return await this._get(`${this.base_url}/api/employees`, criteria); }

  /** Gets posts matching the criteria */
  async getPosts(criteria) { return await this._get(`${this.base_url}/api/posts`, criteria); }

  /** Gets translations matching the criteria */
  async getTranslations(criteria) { return await this._get(`${this.base_url}/api/translations`, criteria); }

  /** Gets assets matching the criteria */
  async getAssets(criteria) { return await this._get(`${this.base_url}/api/assets`, criteria); }

  

  // other API methods ........................................................
  
  /** internal method for generating a Basic Auth header. */
  _formatBasicAuth() { return `Basic  ${btoa(this.account_id||""  + ":" + this.api_key)}`; }

  //common methods.
  async _get(url, parms) {
    return await this.doFetch("GET", url, { parms: parms });
  }
  async _post(url, body) {
    return await this.doFetch("POST", url, { body: body });
  }
  async _put(url, body) {
    return await this.doFetch("PUT", url, { body: body });
  }
  async _delete(url, parms) {
    return await this.doFetch("DELETE", url, { parms: parms });
  }
  async doFetch(method, url, payload) {
    if (payload && payload.parms) {
      if (payload.parms) {
        let searchParams = new URLSearchParams();
        for (let key in payload.parms) {
          searchParams.append(key, payload.parms[key]);
        }
        let search = searchParams.toString();
        if (search) url += "?" + search;
      }
    }
    let data = {};
    try {
      let fetchOpts = {
        method: method,
        mode: 'cors',
        headers: new Headers({
          "Content-Type": "application/json"
        }),
      };
      if (this.api_key) {
        fetchOpts.headers.set("Authorization", this._formatBasicAuth());
      }
      if (method === "POST" || method === "PUT") {
        if (payload && payload.body) {
          fetchOpts.body = JSON.stringify(payload.body);
        }
      }
      let response = await fetch(url, fetchOpts);
      if ([401, 403].indexOf(response.status) >= 0) {
        throw new ApiAuthorizationError("Unauthorized.", response.status);
      } else if (response.status >= 400 && response.status < 500) {
        data = await response.json();
        throw new ApiError(data.message||data.error||"Data error.", response.status, data);
      } else if (response.status >= 500) {
        data = await response.json();
        throw new ApiError(data.message||data.error||"Server error.", response.status, data);
      } else if (response.ok) {
        data = await response.json();
      }
      return data;
    } catch (ex) {
      if (ex instanceof ApiError) throw ex;
      console.error(ex);
      console.error(`${method} ${url} error. ${ex.message}`);
      throw new ApiError(ex.message);
    }
  }

}

/**
 * API-related error.
 */
export class ApiError extends Error {
  constructor(msg, status, details){
    super(msg);
    this.status = status;
    this.details = details;
  }
}
export class ApiAuthorizationError extends ApiError {}
/**
 * @returns an instance of the API class
 */
export default function(){
  return new Api();
}